const defaultState = {
  config: {},
  error: null,
  fetching: false,
  fetched: false
};

const getConfigReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CONFIG_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'CONFIG_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, config: action.payload.data
      };
    }
    case 'CONFIG_FETCH_REJECTED': {
      return {
        ...state, fetching: true, fetched: false, error: action.playload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getConfigReducer;


// WEBPACK FOOTER //
// ./src/reducers/getConfig.js